import { render, staticRenderFns } from "./multipleProductsForm.vue?vue&type=template&id=36979b17&scoped=true"
import script from "./multipleProductsForm.vue?vue&type=script&lang=js"
export * from "./multipleProductsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36979b17",
  null
  
)

export default component.exports